import React from "react";
import * as PRTNR from "../../prtnr";
import { Frame1409 } from "./styles";

export default function PersonalInfoForm({
  formData,
  hasSubmitted,
  fieldErrors,
  handleInputChange,
}) {
  return (
    <>
      <Frame1409>
        <PRTNR.Input
          name="first_name"
          label="First name"
          value={formData.first_name}
          onChange={(e) => handleInputChange("first_name", e.target.value)}
          required
          error={hasSubmitted && fieldErrors.first_name}
          errorMessage={fieldErrors.first_name}
          enableTracking={true}
        />

        <PRTNR.Input
          name="last_name"
          label="Last name"
          value={formData.last_name}
          onChange={(e) => handleInputChange("last_name", e.target.value)}
          required
          error={hasSubmitted && fieldErrors.last_name}
          errorMessage={fieldErrors.last_name}
          enableTracking={true}
        />
      </Frame1409>

      <PRTNR.Input
        name="email_address"
        label="Email address"
        value={formData.email_address}
        onChange={(e) => handleInputChange("email_address", e.target.value)}
        required
        error={hasSubmitted && fieldErrors.email_address}
        errorMessage={fieldErrors.email_address}
        enableTracking={true}
      />

      <PRTNR.Input
        name="phone_number"
        label="Phone Number"
        value={formData.phone_number}
        onChange={(e) => handleInputChange("phone_number", e.target.value)}
        required
        error={hasSubmitted && fieldErrors.phone_number}
        errorMessage={fieldErrors.phone_number}
        enableTracking={true}
      />

      <Frame1409>
        <PRTNR.Input
          name="job_title"
          label="Job title"
          value={formData.job_title}
          onChange={(e) => handleInputChange("job_title", e.target.value)}
          required
          error={hasSubmitted && fieldErrors.job_title}
          errorMessage={fieldErrors.job_title}
          enableTracking={true}
        />

        <PRTNR.Select
          name="seniority"
          label="Seniority"
          value={formData.seniority}
          options={[
            { value: "", label: "Select seniority" },
            { value: "C-level", label: "C-level" },
            { value: "Consultant", label: "Consultant" },
            { value: "Senior Management", label: "Senior Management" },
            { value: "Manager", label: "Manager" },
            { value: "Assistant", label: "Assistant" },
            { value: "Junior Professional", label: "Junior Professional" },
          ]}
          onChange={(e) => handleInputChange("seniority", e.target.value)}
          required
          error={hasSubmitted && fieldErrors.seniority}
          errorMessage={fieldErrors.seniority}
        />
      </Frame1409>

      <Frame1409>
        <PRTNR.Input
          id="city"
          name="city"
          label="City"
          value={formData.city}
          onChange={(e) => handleInputChange("city", e.target.value)}
          required
          error={hasSubmitted && fieldErrors.city}
          errorMessage={fieldErrors.city}
          enableTracking={true}
        />

        <PRTNR.Select
          name="country_of_residence"
          label="Country of residence"
          options={[{ value: "United Kingdom", label: "United Kingdom" }]}
          value={formData.country_of_residence}
          onChange={(e) =>
            handleInputChange("country_of_residence", e.target.value)
          }
          required
          error={hasSubmitted && fieldErrors.country_of_residence}
          errorMessage={fieldErrors.country_of_residence}
        />
      </Frame1409>
    </>
  );
}
